import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { PopoverModule } from 'primeng/popover';
import { ButtonComponent } from '../buttons/button.component';
import { ActionRowComponent } from './action-row.component';
import { DialogComponent } from './dialog.component';

@Component({
  selector: 'app-confirm-tab-dialog',
  imports: [
    PopoverModule,
    CommonModule,
    DialogComponent,
    ActionRowComponent,
    ButtonComponent,
  ],
  template: ` <app-dialog
    #dialog
    [visible]="visible"
    [closable]="true"
    label="Confirmation"
    width="30rem"
    (visibleChange)="onVisibleChange($event)"
  >
    <ng-template #content>
      <div class="tw-pt-2 tw-pb-8">
        You're opening a new tab or window to an external site.<br />Please
        disable popup blockers if needed.
      </div>
      <app-action-row>
        <app-button (click)="onConfirm()" right1 label="Continue" />
        <app-button
          (click)="visible = false"
          emphasis="Low"
          right2
          label="Back"
        />
      </app-action-row>
    </ng-template>
  </app-dialog>`,
  styles: ``,
})
export class ConfirmTabDialogComponent {
  @Output()
  confirm = new EventEmitter();

  protected visible = false;

  show(): void {
    this.visible = true;
  }

  onConfirm() {
    this.visible = false;
    this.confirm.emit();
  }

  onVisibleChange(visible: boolean) {
    this.visible = visible;
  }
}
